import { Module } from 'vuex';
import { EventPayload } from '@/ts-definitions';
import { RootStore } from '../rootStore';

export type ConfigStore = {
  updateAllOutdatedEnabled: boolean;
  updateOutdatedEnabled: boolean;
  // scheduledMaintenance not implemented yet
  // update App.vue in the next maintenance window
  scheduledMaintenance?: {
    message: string;
    startTime: number;
    endTime: number;
  };
};

const initialState: ConfigStore = {
  updateAllOutdatedEnabled: true,
  updateOutdatedEnabled: true,
  scheduledMaintenance: {
    message:
      '<b>Scheduled Maintenance</b> <br /> Our product search will be down for scheduled maintenance on (11/4) from 05:00 PM to 06:00 PM PDT',
    startTime: new Date('2022-11-03T00:00:00-07:00').getTime(),
    endTime: new Date('2022-11-04T20:00:00-07:00').getTime(),
  },
};

type ConfigNamespace = 'config';

type ConfigUpdateAllOutdatedEnabledMutation = EventPayload<
  `${ConfigNamespace}/setUpdateAllOutdatedEnabled`,
  Partial<ConfigStore['updateAllOutdatedEnabled']>
>;

type ConfigUpdateOutdatedEnabledMutation = EventPayload<
  `${ConfigNamespace}/setUpdateOutdatedEnabled`,
  Partial<ConfigStore['updateOutdatedEnabled']>
>;

type ConfigScheduledMaintenanceMutation = EventPayload<
  `${ConfigNamespace}/setScheduledMaintenance`,
  Partial<ConfigStore['scheduledMaintenance']>
>;

export type ConfigMutations =
  | ConfigUpdateAllOutdatedEnabledMutation
  | ConfigUpdateOutdatedEnabledMutation
  | ConfigScheduledMaintenanceMutation;

export const configStore: Module<ConfigStore, RootStore> = {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations: {
    setUpdateAllOutdatedEnabled(
      state,
      { payload }: ConfigUpdateAllOutdatedEnabledMutation
    ) {
      state.updateAllOutdatedEnabled = payload;
    },
    setUpdateOutdatedEnabled(
      state,
      { payload }: ConfigUpdateOutdatedEnabledMutation
    ) {
      state.updateOutdatedEnabled = payload;
    },
    setScheduledMaintenance(
      state,
      { payload }: ConfigScheduledMaintenanceMutation
    ) {
      state = Object.assign(state, payload);
    },
  },
};
